import { DynamicStandaloneTag, DynamicStandaloneTagProps } from '@/components/Tag';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { ArticleFooter } from './ArticleFooter';

export interface StandaloneArticleFooterProps
  extends StandaloneComponentProps<typeof ArticleFooter, { $tag?: DynamicStandaloneTagProps }> {
  tags?: DynamicStandaloneTagProps[];
}

export const StandaloneArticleFooter: StandaloneComponent<StandaloneArticleFooterProps> = ({ tags, options }) => {
  const { $line, $tags, $tag, ...$base } = options ?? {};

  return (
    <ArticleFooter {...$base}>
      <ArticleFooter.Line {...$line} />
      <ArticleFooter.Tags {...$tags}>
        {tags?.map((tag, index) => (
          <DynamicStandaloneTag
            key={index}
            value={tag.value}
            link={tag.link}
            {...mergeProps(
              {
                options: {
                  size: 'medium',
                },
              },
              $tag
            )}
          />
        ))}
      </ArticleFooter.Tags>
    </ArticleFooter>
  );
};

export default StandaloneArticleFooter;
